var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgErrorWarning = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 14.6667C4.3168 14.6667 1.33203 11.6819 1.33203 8.00004C1.33203 4.31814 4.3168 1.33337 7.9987 1.33337C11.6806 1.33337 14.6654 4.31814 14.6654 8.00004C14.6654 11.6819 11.6806 14.6667 7.9987 14.6667ZM7.9987 13.3334C10.9442 13.3334 13.332 10.9456 13.332 8.00004C13.332 5.05452 10.9442 2.66671 7.9987 2.66671C5.05318 2.66671 2.66536 5.05452 2.66536 8.00004C2.66536 10.9456 5.05318 13.3334 7.9987 13.3334ZM7.33203 10H8.66536V11.3334H7.33203V10ZM7.33203 4.66671H8.66536V8.66671H7.33203V4.66671Z",
    fill: "#FF9B04"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgErrorWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/error-warning.0dab175f.svg";
export { ForwardRef as ReactComponent };